/* eslint-disable camelcase */
import { pushToDataLayer } from '../analytics/pushToDataLayer';
import { eventKeyCodes } from '../helpers/eventKeyCodes';

/**
 * Callback when project is selected by user.
 * Sets selected product.
 * Calls service for next step and product info data.
 * @param {Event} event - input ckeck event
 * @param {Object} classInstance
 */
function onProductSelected(event, classInstance) {
  // Cancel event if clicked inside size container
  if ($(event.target).parents('.sample-order-product-size-container').length) {

    return;
  }

  $('.js-sample-error').addClass('hide');
  const $input = $(event.currentTarget).find('.js-sample-order-product-select');
  const $product = $input.parents('.js-sample-product');
  const $productSize = $product.find('.js-form-sample-size');
  const productId = $product.data('productid');

  if ($productSize) {
    $product.find('.js-form-sample-size-required-message')
      .toggleClass('u-display-block', $productSize.val() === '');

    if ($productSize.val() === '') {
      classInstance.productSizeSelected = false;
      event.preventDefault();

      return;
    }
    classInstance.productSizeSelected = $productSize.val();
  }
  classInstance.productSelected = $input.val();
  classInstance.productSelectedName = $input.data('productname');
  classInstance.answer = false;
  classInstance.sendStep({ currentStep: classInstance.step });
  classInstance.getProductInfo($input.attr('data-productInfo-url'), $input);
  sessionStorage.setItem('currentId', productId);

  pushToDataLayer({
    event: 'ga4_sample_form',
    ga4_data: {
      action_type: 'Find the right product',
      step_name: 'Choose your product',
      step_number: classInstance.step,
      single_item_id: productId,
      single_item_name: $product.data('productname')
    }
  });
}

/**
 * Select product
 * @param {Object} classInstance
 * @param {Boolean} deselect
 */
export function selectProduct(classInstance, deselect) {
  if (deselect) {
    classInstance.productSelected = false;
  }

  $('.js-sample-order-product-select').each((index, input) => {
    input.checked = input.value === classInstance.productSelected;
  });
}

/**
 * Adds select product step events
 * @param {Object} classInstance
 */
export function addSelectProductEvents(classInstance) {
  $('.sample-product-box').on('click keydown', event => {
    if (event.type === 'click' || (event.type === 'keydown' && event.keyCode === eventKeyCodes.enter)) {
      onProductSelected(event, classInstance);
    }
  });
  $('.js-form-sample-size').change(event => $(event.currentTarget).parents('.js-sample-product')
    .find('.js-form-sample-size-required-message')
    .removeClass('u-display-block'));
}
